var exports = {
  "u": "CustomerStory__zFIIUr",
};

module.exports = exports;
